import { useMutation } from '@tanstack/react-query';

import { post } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { PaymentResponse, TransferMoneyRequest } from '@generated-types';

const moneyTransferSubmit = async (data: TransferMoneyRequest) =>
    post<PaymentResponse>(`${KREDITTBANKEN_BASE_URL}/transfers/card-to-account`, data);

export const useTransferToAccountMutation = () =>
    useMutation({
        mutationKey: ['payments mutation'],
        mutationFn: moneyTransferSubmit,
        retry: false,
    });
